/*
 * Dots for a scroll-snap row. Any number of sliders on a page.
 *
 *   <section data-snap-slider>
 *     <div data-snap-rail> ...one child per card... </div>
 *     <div data-snap-dots>
 *       <button type="button" data-snap-dot aria-current="true"></button> ...one per card
 *     </div>
 *   </section>
 *
 * Found by the data attributes, never by class. The active dot is the card whose
 * scroll stop is nearest the current position (the card's left edge less the
 * rail's scroll-padding), and the last dot once the rail is scrolled to its end.
 * A share of the scroll distance would not do: cards stop growing at a max width,
 * so on a wider phone the scrollable range shrinks while the cards do not, and a
 * ratio lands between cards. A click scrolls the rail to that card. The rail is a
 * tab stop only while there is something to scroll.
 *
 * Safe to include more than once on a page: a slider is set up once, marked with
 * data-snap-ready.
 */
(function () {
    'use strict';

    function init(root) {
        if (root.getAttribute('data-snap-ready')) return;

        var rail = root.querySelector('[data-snap-rail]');
        var dots = root.querySelectorAll('[data-snap-dots] [data-snap-dot]');
        if (!rail || !dots.length) return;

        root.setAttribute('data-snap-ready', 'true');

        var cards = rail.children;

        function target(i) {
            var pad = parseFloat(window.getComputedStyle(rail).scrollPaddingLeft) || 0;
            var left = cards[i].getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft - pad;
            var max = rail.scrollWidth - rail.clientWidth;
            return Math.max(0, Math.min(left, max));
        }

        function sync() {
            var scrollable = rail.scrollWidth - rail.clientWidth;
            var count = Math.min(cards.length, dots.length);
            var active = 0;
            var best = Infinity;
            var i;

            rail.tabIndex = scrollable > 0 ? 0 : -1;

            if (scrollable > 0 && rail.scrollLeft >= scrollable - 1) {
                active = count - 1;
            } else {
                for (i = 0; i < count; i++) {
                    var gap = Math.abs(target(i) - rail.scrollLeft);
                    if (gap < best) {
                        best = gap;
                        active = i;
                    }
                }
            }

            for (i = 0; i < dots.length; i++) {
                dots[i].setAttribute('aria-current', i === active ? 'true' : 'false');
            }
        }

        function bind(i) {
            dots[i].addEventListener('click', function () {
                if (!cards[i]) return;
                rail.scrollTo({ left: target(i), behavior: 'smooth' });
            });
        }

        for (var d = 0; d < dots.length; d++) {
            bind(d);
        }

        rail.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        sync();
    }

    function run() {
        Array.prototype.forEach.call(document.querySelectorAll('[data-snap-slider]'), init);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }
})();
